
const Button = (props) => {
	return (
		<button
			className={props.className}
			onClick={props.onClick}
			onMouseEnter={props.onMouseEnter}
			onMouseLeave={props.onMouseLeave}
			disabled={props.disabled}
			style={props.style ?? props.style}
		>
			{props.children}
		</button>
	);
};
export default Button;
